import { ContentTop } from "common/src/component/ContentTop";
import GamesLoader from "common/src/component/GamesLoader";
import Lobby from "common/src/component/Lobby";
import SearchResults from "common/src/component/SearchResults";
import Tables from "common/src/component/Tables";
import { SERVER_SETUP, SWE_LIMIT_DIALOG } from "common/src/helpers/constants";
import { getToken } from "common/src/helpers/session";
import useGetGameLobby from "common/src/services/useGetGameLobby";
import { useEffect, useState } from "react";
import { withRouter } from "react-router";
import {
  EmptyCategoriy,
  GameCategoryHeader,
  GameCategoryTitle,
  LobbyWrapper,
} from "common/src/styledComponents/StyledGame";
import config from "../config.json";
import { GameProvidersInLobby } from "common/src/component/GameProvidersInLobby";
// import { GameThemeProviders } from "common/src/component/GameThemeProviders";
import { useTranslation } from "react-i18next";
import { ReactComponent as Telescope } from "common/src/assets/icon-component/telescope.svg";

const Games = ({
  currency,
  server,
  searchResults,
  setSweLimitDialog,
  titles,
  width,
  player,
  skin,
  vendorsImagePath,
  setSearchResults,
  setSpinner,
  setSelectedCategory,
  selectedCategory,
}) => {
  const [serverSetup] = useState(sessionStorage.getObject(SERVER_SETUP));
  const [scrollOnBack, setScrollOnBack] = useState(false);
  const [selectedGameType, setSelectedGameType] = useState(null);
  const [themeSerachTerm, setThemeSearchTerm] = useState("");
  const { t } = useTranslation("");
  const [themeExists, setThemeExists] = useState(false);

  const playerCountry =
    getToken() !== null
      ? player.country
      : serverSetup.geoIP.isoCode.toLowerCase()
      ? serverSetup.geoIP.isoCode.toLowerCase()
      : config.defaultLang;

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
    });
  };
  useEffect(() => {
    window.onpopstate = () => {
      setScrollOnBack(true);
    };
    scrollToTop();
    setSelectedCategory(null);
  }, []);

  useEffect(() => {
    scrollToTop();
  }, [selectedGameType]);

  useEffect(() => {
    document.title = titles["games"];
  }, [titles]);

  useEffect(() => {
    if (localStorage.getItem(SWE_LIMIT_DIALOG) && getToken()) {
      setSweLimitDialog(true);
    }
  }, [setSweLimitDialog]);

  useEffect(() => {
    if (scrollOnBack) {
      scrollToTop();
    }
  }, [scrollOnBack]);

  let { orderedGameLobby, tournamentGame } = useGetGameLobby(
    playerCountry,
    "",
    config.skin
  );

  return (
    <>
      <ContentTop
        showProfileMenu={false}
        showSearch={true}
        serverSetup={serverSetup}
        gameImagePath={config.gameImagePath}
        defaultLang={config.defaultLang}
        skin={skin}
        pages={true}
        gameSearch={true}
      />
      <LobbyWrapper>
        <div>
          <GameCategoryHeader provider gameTheme>
            <GameCategoryTitle category>
              {t("label_chose_provider", "Filter Provider:")}
            </GameCategoryTitle>
          </GameCategoryHeader>
          <GameProvidersInLobby
            serverSetup={serverSetup}
            vendorsImagePath={vendorsImagePath}
            setSearchResults={setSearchResults}
            setSelectedGameType={setSelectedGameType}
            categoryNameForSearch={"from-game"}
            lobby={orderedGameLobby}
            clearResults={true}
            setSpinner={setSpinner}
          />
          <br></br>
          {orderedGameLobby === null ? (
            <GamesLoader skin={config.skin} />
          ) : (
            <Lobby
              gamesForCategory={false}
              gameLobby={
                selectedGameType !== null
                  ? selectedGameType
                  : orderedGameLobby.lobby
              }
              width={width}
              skin={config.skin}
              gameImagePath={config.gameImagePath}
              config={config}
              country={playerCountry}
              providerIsChosen={selectedGameType}
              setSelectedGameType={setSelectedGameType}
              selectedCategory={selectedCategory}
              themes={true}
              setThemeSearchTerm={setThemeSearchTerm}
              themeSerachTerm={themeSerachTerm}
              setSearchResults={setSearchResults}
              accountRoute={true}
              setSpinner={setSpinner}
              setThemeExists={setThemeExists}
              setSelectedCategory={setSelectedCategory}
            />
          )}
          <EmptyCategoriy
            hide={
              selectedGameType === null ||
              (selectedGameType && selectedGameType[0].games.length > 0)
            }
          >
            <Telescope />
            <h2> {t("label_unable_to_find", "No results found!")}</h2>
            <div>
              {t(
                "label_unable_to_find_discription",
                "We are unable to find any games by selected provider"
              )}
            </div>
          </EmptyCategoriy>
          {/*{themeExists && (*/}
          {/*  <GameCategoryHeader provider gameTheme>*/}
          {/*    <GameCategoryTitle category>*/}
          {/*      {t("label_chose_theme")}*/}
          {/*    </GameCategoryTitle>*/}
          {/*  </GameCategoryHeader>*/}
          {/*)}*/}
          {/*<GameThemeProviders*/}
          {/*  setThemeSearchTerm={setThemeSearchTerm}*/}
          {/*  themeSerachTerm={themeSerachTerm}*/}
          {/*  setSearchResults={setSearchResults}*/}
          {/*  skin={config}*/}
          {/*  accountRoute={true}*/}
          {/*  serverSetup={serverSetup}*/}
          {/*  setSelectedGameType={setSelectedGameType}*/}
          {/*  setSpinner={setSpinner}*/}
          {/*  setSelectedCategory={setSelectedCategory}*/}
          {/*  setThemeExists={setThemeExists}*/}
          {/*/>*/}
        </div>
      </LobbyWrapper>
      {config.skin === "rac" && tournamentGame !== null && (
        <Tables
          gameLobby={orderedGameLobby}
          server={server}
          playerCurrency={currency}
          tournamentGame={tournamentGame}
          gameImagePath={config.gameImagePath}
          skin={config.skin}
        />
      )}
    </>
  );
};

export default withRouter(Games);
